import React from "react";
import { Box, Typography, useTheme, Link } from "@mui/material";

const Footer = () => {
  const theme = useTheme(); // Access the theme inside Footer

  return (
    <Box sx={{ textAlign: "center", py: 2, backgroundColor: theme.palette.primary.dark }}>
      <Typography variant="body2" color="textSecondary">
        <Link href="/privacy-policy">Privacy Policy</Link>
      </Typography>
      <Typography variant="body2" color="textSecondary">
        &copy; 2024/2025 Rocket Offer. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;